import { render, staticRenderFns } from "./Dotacion.vue?vue&type=template&id=79cbff2d&scoped=true&"
import script from "./Dotacion.vue?vue&type=script&lang=js&"
export * from "./Dotacion.vue?vue&type=script&lang=js&"
import style0 from "./Dotacion.vue?vue&type=style&index=0&id=79cbff2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cbff2d",
  null
  
)

export default component.exports